import { useLanguage } from '../i18n/LanguageContext';

const FLAGS = {
  fr: '🇫🇷',
  en: '🇬🇧',
  it: '🇮🇹',
  de: '🇩🇪',
};

const LABELS = {
  fr: 'FR',
  en: 'EN',
  it: 'IT',
  de: 'DE',
};

export default function LanguageSelector({ className = '' }) {
  const { lang, setLang, SUPPORTED_LANGS } = useLanguage();

  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="language-selector">
      {SUPPORTED_LANGS.map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          className={`px-2 py-1 text-xs font-medium rounded transition-all ${
            lang === l
              ? 'bg-[#0a57a4] text-white'
              : 'text-[#858275] hover:text-[#0a57a4] hover:bg-[#dec5ae]/20'
          }`}
          data-testid={`lang-${l}-btn`}
          title={LABELS[l]}
        >
          {FLAGS[l]}
        </button>
      ))}
    </div>
  );
}
